import { Phone } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { BUSINESS } from "../lib/site";

const STEPS = [
    {
        num: "01",
        title: "Call or send the form",
        body: 'Call or text, or use the free quote form. Tell us the stump size — the diameter across the root flare at ground level — and your access situation.',
    },
    {
        num: "02",
        title: "Locked in this week",
        body: "We schedule your job within the same week, Monday through Saturday, 7AM–6PM. You get a firm day, not a someday.",
    },
    {
        num: "03",
        title: 'Ground 6–8" below grade',
        body: 'The stump and its surface roots are ground 6–8 inches below grade so you can mow, plant, or rebuild over it.',
    },
    {
        num: "04",
        title: "Cleanup, your call",
        body: "Standard: grindings raked back into the hole. Want it gone? Add chip haul-off, topsoil, seed + straw, or full lawn restoration.",
    },
];

const ProcessSection = () => (
    <section className="bg-brand-surface border-y border-brand-line" data-testid="process-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24">
            <Reveal className="mb-14">
                <Eyebrow className="mb-4">How it works</Eyebrow>
                <h2 className="font-display font-black uppercase text-brand-cream text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
                    Four steps. One week. <span className="text-brand-amber">Zero stumps.</span>
                </h2>
            </Reveal>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-line border border-brand-line rounded-lg overflow-hidden">
                {STEPS.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.08} className="h-full">
                        <div
                            data-testid={`process-step-${s.num}`}
                            className="group h-full bg-brand-surface hover:bg-brand-elevated transition-colors duration-300 p-7 sm:p-8 flex flex-col min-h-[260px]"
                        >
                            <span className="font-mono text-brand-amber text-sm mb-8">{s.num}</span>
                            <h3 className="font-display font-bold uppercase text-brand-cream text-2xl tracking-tight leading-none mb-4">
                                {s.title}
                            </h3>
                            <p className="text-brand-sage text-sm leading-relaxed">{s.body}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal className="mt-10 flex justify-center" delay={0.1}>
                <a
                    href={BUSINESS.phoneTel}
                    data-testid="process-call-cta"
                    className="inline-flex items-center gap-3 bg-brand-amber text-brand-ink font-bold px-8 py-4 rounded-full hover:bg-brand-amberHover transition-colors"
                >
                    <Phone className="w-5 h-5" />
                    Start at step one — {BUSINESS.phoneDisplay}
                </a>
            </Reveal>
        </div>
    </section>
);

export default ProcessSection;
